module.exports = __webpack_public_path__ + "media/svg-new/raking-e72e9005.svg";